export const countUnreadChats = (conversations = []) =>
  conversations.filter((conversation) => (conversation.unreadCount || 0) > 0).length;

const listeners = new Set();

export const publishCmChatUnread = (conversations = []) => {
  const unreadChatCount = countUnreadChats(conversations);
  listeners.forEach((listener) => listener(unreadChatCount, conversations));
  return unreadChatCount;
};

export const subscribeCmChatUnread = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
